<script>
import arrowImg from '../../../images/arrow-right-circle.svg'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import getCountryISO2 from "country-iso-3-to-2";
import Multiselect from 'vue-multiselect'


export default {
  components:{
    Loading,
    Multiselect
  },
  props: {
    bookingID: Number,
    activeStep: Number,
    totalSteps: Number
  },
  data(){
    return {
      arrowImg: arrowImg,
      isLoading: false,
      budget: '',
      currency: {},
      currencies: [],
      countries: [],
      isCountriesLoaded: false,
      countryFlagCode: null,
      error: null,
      input_currency_slug: null,
      profile_completion: null
    }
  },
  computed: {
    bookingProgress() {
      return this.activeStep * 100 / this.totalSteps
    }
  },
  mounted() {
    this.isLoading = true
    this.$axios.get('/v3/locations')
      .then(response => {
        this.countries = response.data
        this.isCountriesLoaded = true
        this.isLoading = false
      })
    this.$axios.get('/v3/currencies')
    .then(res => {
      this.currencies = res.data.map(currency => ({
        ...currency,
        slug: currency.slug.toUpperCase()
      }))
      .sort((a, b) => a.slug.localeCompare(b.slug))
    })
    this.$axios.get(`/v3/event_bookings/${this.bookingID}`)
      .then(response => {
        this.budget = response.data.original_budget
        this.currency = response.data.currency
        this.getCountryFlagCode()
      })
      .catch(error => {
        this.getCountryFlagCode()
        this.isLoading = false
        this.getCountryFlagCode()
      })
  },
  methods: {
    getCountryFlagCode() {
      this.isLoading = true
      this.isCountriesLoaded = false
      this.$axios.get('/v3/users/profile').then(response => {
        this.profile_completion = response.data.profile_completion
        if (this.profile_completion < 21) {
          const country = this.countries.filter(country => country.slug === response.data.country.slug)[0]
          this.currency = country.currency
          this.input_currency_slug = this.currency
          const flag = getCountryISO2(country.slug.toUpperCase()).toString().toLowerCase();
          this.countryFlagCode = flag
          this.isLoading = false
          this.isCountriesLoaded = true
        } else {
          const country = this.countries.filter(country => country.slug === response.data.country.slug)[0]
          this.currency = country.currency
          const flag = getCountryISO2(country.slug.toUpperCase()).toString().toLowerCase();
          this.input_currency_slug = this.currency.code
          this.countryFlagCode = flag
          this.isLoading = false
          this.isCountriesLoaded = true
        }
      })
      .catch(error => {
        this.isLoading = false
      })
    },
    getFlagCode(code){
      console.log(code, "code", getCountryISO2(code.toUpperCase()))
      if (!code) return 'aed'
      const flag = getCountryISO2(code.toUpperCase()).toString().toLowerCase();
      return flag;
    },
    preventDecimals(e) {
      if (['.', ',', 'e', 'E'].includes(e.key)) {
        e.preventDefault();
      }
    },
    currencyLabel(option) {
      return option.slug
    },
    onCurrencyChange(selected) {
      if (!selected) return
      this.input_currency_slug = selected
      const country = this.countries.filter(country => country.currency && country.currency.slug.toUpperCase() === selected.slug)[0]
      
      this.currency = country.currency
      if (country) { 
        this.countryFlagCode = getCountryISO2(country.slug.toUpperCase()).toString().toLowerCase();
      }
    },
    nextStep(isSkip=false) {
      this.isLoading = true
      let params = {
        booking: {
          budget: isSkip ? null : parseInt(this.budget),
          currency_slug: this.currency.slug.toLowerCase()
        }
      }
      this.$emit('updateStep', { booking_params: params, next_step: 'fill_description' })
    },
    back() {
      let params = {
        booking: {
          budget: parseInt(this.budget),
          currency_slug: this.currency.slug.toLowerCase()
        }
      }
      this.$emit('updateStep', { booking_params: params, next_step: 'select_guest' })
    },
  },
}
</script>

<template>
  <div class="new-booking__art-type new-booking__content">
    <div class="vld-parent">
      <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        color="#FF8141"
      ></loading>
    </div>

    <p class="mt-4 mb-5">
      Letting artists know your budget will give you more accurate results
    </p>

    <div class="new-booking__content">
      <div class="forms__item-100">
        <div class="new-booking__input-budget">
          <div v-if="isCountriesLoaded" class="order-capture-input w-100 position-relative d-flex">
            <span v-if="profile_completion >= 21" class="position-absolute h-100 d-flex align-items-center">
              <img class="img-flg" :src="'/assets/flags/4x3/' + countryFlagCode + '.svg' "/> - <span style="padding-left: 5px;"> {{ this.input_currency_slug }} </span>
            </span>
            <multiselect
              v-if="profile_completion < 21"
              v-model="input_currency_slug"
              :options="currencies"
              placeholder="Select currency"
              :multiple="false"
              :custom-label="currencyLabel"
              label="slug"
              track-by="slug"
              :searchable="false"
              :show-labels="false"
              @input="onCurrencyChange"
            >
              <template #singleLabel="{ option }">
                <img
                  class="inline-block img-flg"
                  :src="'/assets/flags/4x3/' + countryFlagCode + '.svg'"
                  alt=""
                  width="20"
                /> - <span style="padding-left: 5px;"> {{option.code}} </span>
              </template>
            </multiselect>
            <input
              v-model="budget"
              type="number"
              @keydown="preventDecimals"
              :required="true"
              :class="[
                profile_completion < 21 ? 'w-100' : 'w-100',
                { error: error }
              ]"
              :style="profile_completion < 21 ? '' : 'padding-left: 100px'"
              placeholder="Enter maximum budget"
              min=0
            >
          </div>
          <span v-if="error" class="error-message">{{ error? error.toString() : null }}</span>
        </div>

        <button class="w-100 new-booking__skip-budget mb-3"
          @click="nextStep(isSkip=true)"
        >
          Skip
          <img :src="arrowImg" class="ms-1 me-3" style="width: 16px;vertical-align: middle;" />
          Let artists send me quotes
        </button>
      </div>

      <div class="mt-5">
        <div class="back-next">
          <button
            class="settings-forms__btn btn secondary fluid"
            @click="back()">
            Back
          </button>
          <button
            class="settings-forms__btn btn primary fluid"
            @click="nextStep()"
            :disabled="!budget || parseInt(budget) <= 0">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
</style>
